var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-area-drawer',{attrs:{"rectangle":_vm.rectangle,"border-style":_vm.configuredBorderStyle,"paint-style":_vm.configuredPaintStyle,"text-style":_vm.configuredTextStyle,"text":_vm.text}})}
var staticRenderFns = []

export { render, staticRenderFns }